module.exports = __webpack_public_path__ + "img/AufgegessenWerden.2aea6926.jpg";